/**
 * Page-wide prototype patches — verbatim port of the IIFE in v1
 * global_variables.js:40-73 (research/01 §2.3; REQ-BOOT-1b).
 *
 *  - Event.prototype.stopImmediatePropagation: sets the (dead) __stopped
 *    marker, then still genuinely stops propagation.
 *  - EventTarget.prototype.addEventListener: the "guaranteed" click channel —
 *    listeners registered with options === "guaranteed" are diverted to a
 *    document-level capture dispatcher that runs them on EVERY document click
 *    with `this === e.target`; they can never be removed, duplicate on re-add,
 *    and their errors are swallowed with a console.error.
 */
export {};

(function () {
  // Keep original methods
  const origAdd = EventTarget.prototype.addEventListener;
  const origStopImmediate = Event.prototype.stopImmediatePropagation;

  // Patch stopImmediatePropagation so it won't kill our listeners
  Event.prototype.stopImmediatePropagation = function () {
    (this as any).__stopped = true; // mark the event
    origStopImmediate.call(this);
  };

  // Our guaranteed listener storage
  const guaranteedHandlers: any[] = [];

  // Helper to add guaranteed click listeners
  (EventTarget.prototype as any).addEventListener = function (
    type: any,
    listener: any,
    options: any,
  ) {
    if (type === "click" && options === "guaranteed") {
      guaranteedHandlers.push(listener);
    } else {
      origAdd.call(this, type, listener, options);
    }
  };

  // Attach a master listener once to run guaranteed handlers
  document.addEventListener(
    "click",
    function (e) {
      guaranteedHandlers.forEach((fn) => {
        try {
          fn.call(e.target, e);
        } catch (err) {
          console.error("Guaranteed handler error:", err);
        }
      });
    },
    true,
  ); // capture, so we get it first
})();
